import { dispatchAction } from '@ardoq/rxbeach';
import {
  setSelectedView as setSelectedViewAction,
  resetSelectedView as resetSelectedViewAction,
} from './actions';
import { SelectedViewOption } from './types';

export const getSelectedViewCommands = (namespace: string) => ({
  setSelectedView: (viewId: SelectedViewOption) => {
    dispatchAction(setSelectedViewAction(viewId), namespace);
  },
  resetSelectedView: () => {
    dispatchAction(resetSelectedViewAction(), namespace);
  },
});

export type SelectedViewCommands = ReturnType<typeof getSelectedViewCommands>;
